import Modal from "bootstrap/js/src/modal";
import Toolbox from "./toolbox";
import ready from "@/shared/helpers/ready";

ready().then(() => {
    const copyElement = document.getElementById("copyLink");
    const btnSharePopup = document.getElementById('btnSharePopup');

    const modalEl = document.getElementById('shareModal');

    if (modalEl && btnSharePopup) {
        modalEl.addEventListener('show.bs.modal', event => {
            console.debug(event);
        })

        const modal = new Modal(modalEl);

        btnSharePopup.addEventListener('click', () => {
            modal.show();
        });
    }

    if (copyElement) {
        copyElement.addEventListener('click', ()=>{
            console.debug('Copying to clipboard...');
            navigator.clipboard.writeText(window.location.href).then(() => Toolbox.success("Copied to clipboard"));
        });
    }
});
